import { Component, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { PageComponent } from "@components/page/page.component";
import { SaveButtonComponent } from "@components/save-button/save-button.component";
import { TranslatePipe } from "@ngx-translate/core";
import moment from "moment";
import { LagermalRequest, LagermalView } from "../../hantera-lagermal-models";
import { HanteraLagermalFilterComponent } from "../hantera-lagermal-filter/hantera-lagermal-filter.component";
import { HanteraLagermalNavigationComponent } from "../hantera-lagermal-navigation/hantera-lagermal-navigation.component";
import { HanteraLagermalResultComponent } from "../hantera-lagermal-result/hantera-lagermal-result.component";

@Component({
    selector: "rask-hantera-lagermal",
    templateUrl: "./hantera-lagermal.component.html",
    styleUrls: ["./hantera-lagermal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        HanteraLagermalFilterComponent,
        HanteraLagermalNavigationComponent,
        HanteraLagermalResultComponent,
        SaveButtonComponent,
        TranslatePipe
    ]
})
export class HanteraLagermalComponent {

  @ViewChild(HanteraLagermalResultComponent) result: HanteraLagermalResultComponent;

  yearRequest: LagermalRequest;
  view: LagermalView = LagermalView.Dagar;

  viewChange(view: LagermalView) {
      this.view = view;
  }

  yearChange(yearChange: number) {
      const newRequest = Object.assign({}, this.yearRequest);
      newRequest.period = moment(newRequest.period).add(yearChange, "year").toDate() as any;
      this.yearRequest = newRequest;
  }

  requestChange(request: LagermalRequest) {
      this.yearRequest = request;
  }

}
